import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StatistikDaekningKundeFaktura } from '../../models/StatistikDaekningKundeFaktura';

@Component({
    selector: 'app-statistik-daekning-faktura-ui',
    templateUrl: './statistik-daekning-faktura-modal.html',
    styleUrls: ['./statistik-daekning-faktura-modal.scss'],
    standalone: false
})
export class StatistikDaekningFakturaModal {
    @Input() faktura: StatistikDaekningKundeFaktura[];

    constructor(
        private activeModal: NgbActiveModal,
    ) { }

    onDismiss() {
        this.activeModal.dismiss();
    }

    amountTotal() {
        let total = 0;
        this.faktura.forEach(faktura => {
            total += faktura.beloeb;
        });
        return Math.round(total);
    }
}
